/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_SaveInputs */

const en_task_reminders_save = /** @type {(inputs: Task_Reminders_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save reminder`)
};

const pt_br2_task_reminders_save = /** @type {(inputs: Task_Reminders_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar lembrete`)
};

/**
* | output |
* | --- |
* | "Save reminder" |
*
* @param {Task_Reminders_SaveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_save = /** @type {((inputs?: Task_Reminders_SaveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_SaveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_save(inputs)
	return pt_br2_task_reminders_save(inputs)
});